import compose from 'react-hooks-compose'

import { useUsuarioPageNavLogic } from './useLogic'
import { UsuarioPageNavPresenter } from './presenter'

export const UsuarioPageNav = compose(props => ({
	useLogic: () => useUsuarioPageNavLogic(props),
}))(UsuarioPageNavPresenter)
